// Chrome用.
import * as React from 'react';
import { BaseBrowser } from './BaseBrowser';
import { Male, Female } from '../../constants/UserListField';
import * as HomeVisit from '../../constants/HomeVisit';
import * as Enumerable from 'linq';

// Chrome. 
export class Chrome extends BaseBrowser {
  renderCSS(): JSX.Element {
    return (
      <style type="text/css">
      {'#homevisit { padding-left: 2.75cm; }'}

      {/* 縦印刷, 日付・title名は消す */}
      {'@media print{@page {size: A4; margin: 0; '
      + 'margin-top: 4mm; margin-left: 1cm; margin-right: 1cm; margin-bottom: 0mm; } '
      + '#wrapper { margin-top: 0; } header { display: none; } '
      + 'body { padding: 8; } '
      + '#homevisit { padding-left: 0; padding-right: 0; } '
      + '#sec01 { display: none; }}'}

      {'.table { display:table; border-width: 1px 1px 1px 1px; width: 20.5cm; height: 29.0cm; }'}
      
      /* 生年用 */
      {'.birthYearAlign { padding-left: 5px; text-align: left; vertical-align: middle; }'}
      
      /* 歳用 */
      {'.ageAlign { padding-right: 5px; text-align: right; vertical-align: middle; }'}
      
      /* 中央揃え */
      {'.centerAlign { text-align: center; vertical-align: middle; }'}
      
      /* 中央揃え */
      {'.centerAlign { text-align: center; vertical-align: middle; }'}
      
      /* 左上詰め */
      {'.leftUpStack  { text-align: left; vertical-align: top; } '}
      
      /* 左詰め */
      {'.leftStack { text-align: left; vertical-align: middle; } '}
      
      /* タイトル */
      {'.titleName { font-weight: bold; text-align: center; } '}
      
      {'.intable { display:table; width:100%; height:100%; } '}
      
      /* 各項目系 */
      {'.sectionIntable { display:table; width:100%; /* 100% / 項目数 */ height: 16.7169%; } '}
      
      /* 起居動作 */
      {'.kikyoSectionIntable { display:table; width:100%; /* 100% / 項目数 */ height: 25.3%; } '}
      
      /* これを合計17にする */
      {'.cell1 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}

      {'.cell1_5 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*1.5); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}

      {'.cell2 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*2); '
      + 'display: table-cell; border-style: solid; border-color: black; } '}

      {'.cell2_5 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*2.5); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      {'.cell3 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*3); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}

      {'.cell3_5 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*3.5); '
      + 'display: table-cell; border-style: solid; border-color: black; } '}

      {'.cell4 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*4); '
      + 'display: table-cell; border-style: solid; border-color: black; } '}

      {'.cell4_5 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*4.5); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}

      {'.cell5 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*5); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}

      {'.cell8 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*8); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      {'.cell9 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*9); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      {'.cell9_5 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*9.5); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      {'.cell10 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: calc(100%/17*10); '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      
      /* ADL, IADL, 起居動作のタイトル用cell2 */
      {'.secTitleCell2 { table-layout: fixed; border-width: 1px 0px 1px 0px; width: 11.7%; '
      + 'display:table-cell; border-style: solid; border-color: rgb(29, 22, 22); } '}
      
      /* 項目の塊用 */
      {'.chaptersCell { table-layout: fixed; border-width: 0px 0px 0px 1px; width: 64.8%; '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      
      /* 下段項目の塊用 */
      {'.chaptersBottomCell { table-layout: fixed; border-width: 0px 0px 0px 0px; width: 41.3%; '
      + 'display:table-cell; border-style: solid; border-color: black; }'}
      
      /* 空行 */
      {'.blankCell { table-layout: fixed; width:100%; display:table-cell; }'}
      
      {'.topRow { height: 1.0%; }'}
      
      {'.row1 { height: 2.4%; }'}
      
      /* ADLの行 */
      /* 100-row1*5-blankRow/(6*2+4)*6 */
      {'.rowADL { height: 31.2%; }'}

      /* IADLの行 */
      {'.rowIADL { height: 31.2%; }'}
      
      {'.blankRow { height: 1.8%; }'}
      
      /* 起居動作の行 */
      {'.rowKikyo { height: 20.9%; }'}

      {'.cell { display: table-cell; table-layout: fixed; }'}
      {'.row { display: table-row; }'}
      {'.cell { border-width: 0px 0px 1px 1px; width:25%; }'}
      
      /* レベル */
      {'.levelTable { display: table; width: 100%; height: 50%; }'}
      
      /* レベル中身 */
      {'.levelItem { display: table-cell; table-layout: fixed; width: 50%; height: 100%; '
      + 'border-width: 0px 0px 0px 1px; text-align: left; vertical-align: middle; }'}
      
      /* 項目の中身を4つに分けたもの */
      /* 上段 */
      {'.sectionUpCell1 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: 18.3%; '
      + 'display:table-cell; border-style: solid; border-color: black; }'}
      {'.sectionUpCell2 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: 36.5%;'
      + 'display:table-cell; border-style: solid; border-color: black; }'}
      {'.sectionUpCell3 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: 9%; '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      {'.sectionUpCell4 { table-layout: fixed; border-width: 1px 1px 1px 1px; display:table-cell; '
      + 'border-style: solid; border-color: black; } '}
      
      /* 下段・中身を3つに分けたもの */
      {'.sectionBottomCell1 { table-layout: fixed; border-width: 1px 1px 1px 1px; width: 29%; '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      {'.sectionBottomCell2 { table-layout:  fixed; border-width: 1px 1px 1px 1px; width: 57.2%; '
      + 'display:table-cell; border-style: solid; border-color: black; } '}
      {'.sectionBottomCell3 { table-layout:  fixed; border-width: 1px 1px 1px 1px; display:table-cell; '
      + 'border-style: solid; border-color: black; } '}
      
      /* 最初だけ太いので */
      {'.firstCell { border-left-width: 2px; }'}
      
      /* 最後だけ太いので */
      {'.lastCell { border-right-width: 2px; }'} 
      /* トップだけ太いので */
      {'.topCell { border-top-width: 2px; }'} 
      /* 底だけ太いので */
      {'.bottomCell { border-bottom-width: 2px; }'} 
      /* 背景色 */
      {'.bgColor { background-color: #F2F2F2; }'} 
      </style>
    );
  }

  /**
   * 上段用(ADL/IADL)の各項目のJSXの描画.
   * @method renderTopSection
   * @param {Boolean} isBottom 最終行(bottomCellが入るため).
   * @param {String} itemName 項目タイトル名.
   * @param {HomeVisit.Multiple} multiple 連想配列.
   * @return {JSX.Element[]} JSXの配列.
   */
  renderTopSection(isBottom: boolean, itemName: string, multiple: HomeVisit.Multiple): JSX.Element {
    // multipleを分離.
    // レベルの内容の配列(自立=0、見守り=1、一部介助=2、全介助=3).
    let levels: number[] = [];
    // 課題の有無.
    let isProblem: boolean = false;

    // 環境(実施場所、補助具など)(falseなら下段なので非表示).
    let env: boolean|string =  false;

    if (multiple) {
      levels = multiple ? multiple.level : [];
      isProblem = multiple ? multiple.is_problem : false;
      env = (multiple.env === undefined) ? false : multiple.env;
    }

    // number[] -> boolean[]
    const levelsBools: boolean[] = Enumerable.range(0, 4).select((i: number) => {
      return (levels.indexOf(i) > -1);
    }).toArray();

    const check = (isCheck: boolean): string => {
      return isCheck ? '■' : '□';
    };

    const problem: string = isProblem ? '有' : '無';
    const bottomTag: string = isBottom ? 'bottomCell ' : '';

    return (
      <div className="sectionIntable">
        <div className={`${bottomTag} centerAlign sectionUpCell1`}>
          {itemName}
        </div>
        <div className={`${bottomTag} sectionUpCell2`}>
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[0])} 自立
            </div>
            <div className="levelItem">
              {check(levelsBools[1])} 見守り
            </div>
          </div>
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[2])} 一部介助
            </div>
            <div className="levelItem">
              {check(levelsBools[3])} 全介助
            </div>
          </div>
        </div>
        <div className={`${bottomTag} centerAlign sectionUpCell3`}>
          {problem}
        </div>
        <div className={`${bottomTag} leftStack sectionUpCell4`}>{env}</div>
      </div>
    );
  }

  /**
   * 下段用(起居動作)各項目のJSXの描画.
   * @method renderBottomSection
   * @param {String} itemName 項目タイトル名.
   * @param {HomeVisit.Multiple} multiple 連想配列.
   * @return {JSX.Element[]} JSXの配列.
   */
  renderBottomSection(itemName: string, multiple: HomeVisit.Multiple): JSX.Element {
    // multipleを分離.
    // レベルの内容の配列(自立=0、見守り=1、一部介助=2、全介助=3).
    let levels: number[] = [];
    // 課題の有無.
    let isProblem: boolean = false;

    if (multiple) {
      levels = multiple ? multiple.level : [];
      isProblem = multiple ? multiple.is_problem : false;
    }

    // number[] -> boolean[]
    const levelsBools: boolean[] = Enumerable.range(0, 4).select((i: number) => {
      return (levels.indexOf(i) > -1);
    }).toArray();

    const check = (isCheck: boolean): string => {
      return isCheck ? '■' : '□';
    };

    const problem: string = isProblem ? '有' : '無';

    return (
      <div className="kikyoSectionIntable">
        <div className="firstCell centerAlign sectionBottomCell1">
          {itemName}
        </div>
        <div className="sectionBottomCell2">
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[0])} 自立
            </div>
            <div className="levelItem">
              {check(levelsBools[1])} 見守り
            </div>
          </div>
          <div className="levelTable">
            <div className="levelItem">
              {check(levelsBools[2])} 一部介助
            </div>
            <div className="levelItem">
              {check(levelsBools[3])} 全介助
            </div>
          </div>
        </div>
        <div className="centerAlign sectionBottomCell3">
          {problem}
        </div>
      </div> 
    );
  }

  render() {
    if (this.props.moffAPI.result === undefined) {
      return (null);
    }

    this.homeVisit = this.props.moffAPI.result.homeVisit;
    this.user = this.props.moffAPI.result.user;
    this.refresh();

    return (
      <div className="table">
        <div className="row topRow" />
        <div className="row row1">
          <div className="titleName">
            居宅訪問チェックシート
          </div>
        </div>
        {/* <!-- 利用者情報 --> */}
        <div className="row row1">
          <div className="intable">
            <div className="centerAlign firstCell topCell bgColor cell3_5">
              利用者氏名
            </div>
            <div className="centerAlign topCell cell3_5">
              {this.userName}
            </div>
            <div className="centerAlign bgColor topCell cell2">
              生年
            </div>
            <div className="birthYearAlign leftStack cell3 topCell">
              {this.birthYear}年
            </div>
            <div className="ageAlign cell1_5 topCell">
              歳
            </div>
            <div className="centerAlign bgColor topCell cell1_5">
              性別
            </div>
            <div className="centerAlign cell2 topCell lastCell">
              {this.gender === 0 ? Male : Female}
            </div>
          </div>
        </div>
        {/* <!-- 2行目 --> */}
        <div className="row row1">
          <div className="intable">
            <div className="centerAlign firstCell bgColor cell3_5">
              訪問日
            </div>
            <div className="centerAlign cell9_5">
              {this.visitDate}
            </div>
            <div className="centerAlign bgColor cell2">
              要介護度
            </div>
            <div className="centerAlign lastCell cell2">
              {this.careLevel}
            </div>
          </div>
        </div>
        {/* <!-- 3行目 --> */}
        <div className="row row1">
          <div className="intable">
            <div className="centerAlign firstCell bottomCell bgColor cell3_5">
              訪問スタッフ
            </div>
            <div className="centerAlign cell3_5 bottomCell">
              {this.visitStaff}
            </div>
            <div className="centerAlign bgColor cell2 bottomCell">
              職種
            </div>
            <div className="centerAlign cell4 bottomCell">
              {this.profession}
            </div>
            <div className="centerAlign bgColor cell2 bottomCell">
              被聞き取り者
            </div>
            <div className="centerAlign lastCell cell2 bottomCell">
              {this.listenedUser}
            </div>
          </div>
        </div>
        {/* <!-- blank --> */}
        <div className="row blankRow">
          <div className="intable">
            <div className="blankCell" />
          </div>
        </div>
        {/* <!-- 内容タイトル --> */}
        <div className="row row1">
          <div className="intable">
            <div className="firstCell topCell bgColor cell2">
              {/* <!-- 空白 --> */}
            </div>
            <div className="centerAlign bgColor topCell cell2">
              項目
            </div>
            <div className="centerAlign bgColor topCell cell4">
              レベル
            </div>
            <div className="centerAlign bgColor topCell cell1">
              課題
            </div>
            <div className="centerAlign bgColor topCell cell4">
              環境(実施場所、補助具など)
            </div>
            <div className="centerAlign lastCell bgColor topCell cell4">
              状況・生活課題
            </div>
          </div>
        </div>
        {/* <!-- ADL --> */}
        <div className="row rowADL">
          <div className="intable">
            <div className="centerAlign firstCell secTitleCell2">
              ADL
            </div>
            <div className="chaptersCell">
              {/* <!-- 各項目 --> */}
              {/* ADL */}
              {this.renderTopSection(false, '食事', this.homeVisit.adl_feed)}
              {this.renderTopSection(false, '排尿', this.homeVisit.adl_ur)}
              {this.renderTopSection(false, '入浴', this.homeVisit.adl_bath)}
              {this.renderTopSection(false, '更衣', this.homeVisit.adl_dress)}
              {this.renderTopSection(false, '整容', this.homeVisit.adl_cosme)}
              {this.renderTopSection(true, '移乗', this.homeVisit.adl_transfer)}
            </div>
            <div className="leftUpStack cell4 lastCell">
              {/* <!-- 状況・生活課題 --> */}
              {this.homeVisit.adl_detail}
            </div>
          </div>
        </div>
        {/* <!-- IADL --> */}
        <div className="row rowIADL">
          <div className="intable">
            <div className="centerAlign firstCell secTitleCell2">
              IADL
            </div>
            <div className="chaptersCell">
              {/* <!-- 各項目 --> */}
              {/* IADL */}
              {this.renderTopSection(false, '屋内移動', this.homeVisit.iadl_indoor)}
              {this.renderTopSection(false, '屋外移動', this.homeVisit.iadl_outdoor)}
              {this.renderTopSection(false, '階段昇降', this.homeVisit.iadl_lift)}
              {this.renderTopSection(false, '調理', this.homeVisit.iadl_cook)}
              {this.renderTopSection(false, '洗濯', this.homeVisit.iadl_wash)}
              {this.renderTopSection(true, '掃除', this.homeVisit.iadl_clean)}
            </div>
            <div className="leftUpStack cell4 lastCell">
              {/* <!-- 状況・生活課題 --> */}
              {this.homeVisit.iadl_detail}
            </div>
          </div>
        </div>
        {/* <!-- 起居動作・タイトル --> */}
        <div className="row row1">
          <div className="intable">
            <div className="bgColor firstCell cell2">
              {/* <!-- 空白 --> */}
            </div>
            <div className="centerAlign bgColor cell2">
              項目
            </div>
            <div className="centerAlign bgColor cell4">
              レベル
            </div>
            <div className="centerAlign bgColor cell1">
              課題
            </div>
            <div className="centerAlign bgColor cell8 lastCell">
              状況・生活課題
            </div>
          </div>
        </div>
        {/* <!-- 起居動作 --> */}
        <div className="row rowKikyo">
          <div className="intable">
            <div className="centerAlign firstCell secTitleCell2 bottomCell">
              起居動作
            </div>
            <div className="chaptersBottomCell bottomCell">
              {/* <!-- 各項目 --> */}
              {this.renderBottomSection('起き上がり', this.homeVisit.behaivior_arise)}
              {this.renderBottomSection('座位', this.homeVisit.behaivior_sitting)}
              {this.renderBottomSection('立ち上がり', this.homeVisit.behaivior_standup)}
              {this.renderBottomSection('立位', this.homeVisit.behaivior_upright)}
            </div>
            <div className="leftUpStack cell8 lastCell bottomCell">
              {/* <!-- 状況・生活課題 --> */}
              {this.homeVisit.behaivior_detail}
            </div>
          </div>
        </div>
        {this.renderCSS()}
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/HomeVisitPrintBrowsers/Chrome.tsx